export default __webpack_public_path__ + "static/media/CapDownArrow.b1db8e75.svg";